import React, { useEffect } from 'react';
import getConfig from 'next/config';
import { erDomain } from 'data/erDomain';
import { AUTH_TOKEN } from 'utils/constants';

const {
  publicRuntimeConfig: { envVars },
} = getConfig();
const { PROTOCOL } = envVars;

const SSOJs = () => {
  useEffect(() => {
    const messageListener = (msg) => {
      console.log('here at eagleshare', msg.data, msg.origin, `${PROTOCOL}://${erDomain.en}`);
      if (msg.origin === `${PROTOCOL}://${erDomain.en}` && typeof msg.data === 'string') {
        console.log('signed in ', window.location.origin);
        localStorage.setItem(AUTH_TOKEN, msg.data);
      }
    };
    window.addEventListener('message', messageListener);
  });
  return <></>;
};

export default SSOJs;
